import { useCallback } from 'react';

type HapticPattern = 'light' | 'medium' | 'heavy';

const DURATIONS: Record<HapticPattern, number> = {
  light: 10,
  medium: 20,
  heavy: 30,
};

export function useHapticFeedback() {
  const vibrate = useCallback((pattern: HapticPattern = 'medium') => {
    if (!navigator.vibrate) return;
    navigator.vibrate(DURATIONS[pattern]);
  }, []);

  return { vibrate };
}
